/* eslint-env browser, jquery */
import page from 'modules/ab-page-js';
import domify from 'domify';
import container from 'modules/section-content';
import splash from './pages/psaas.pug';
import metadata from './metadata.json';
import psaasPapers from './data/psaasPapers.json';

export default function register() {
  page('/legal/baseline/psaas', render);
}

function render(ctx, next) {
  const renderOptions = {
    metadata,
    psaasPapers,
    // Only pass view on client render.
    ...(ctx.init ? {} : { view: domify(splash()) })
  };
  container.render(renderOptions);

  next();
}



// WEBPACK FOOTER //
// ./src/pages/legals/psaas/psaas.js